export default "__VITE_ASSET__DzVutlSP__"